// PartBPage4.jsx - Secondary Stage Part B Page 4 (Teacher Assessment - Stage 2) for HPC Report
import React from 'react';

const PartBPage4 = ({ data }) => {
  // CORRECT PATH: data.stage2 (not data.teacher_assessment_stage_2)
  const stage2Data = data?.stage2 || {
    awareness: [],
    sensitivity: [],
    creativity: [],
    comments: ''
  };

  const awarenessItems = [
    "The learner shows evidence of sufficient engagement in the process of project work.",
    "The learner is able to present a draft done as per the project schedule.",
    "The learner is able to demonstrate thorough research skills on the project task/topic.",
    "The learner is able to identify possible areas of improvement in the draft.",
    "The learner is aware of different team members' contributions to the project so far.",
    "The product created demonstrates the application of knowledge gain."
  ];

  const sensitivityItems = [
    "The learner participates in group discussions respectfully.",
    "The learner responds appropriately to other group members' emotions during the project.",
    "The learner attempts to build a positive emotional atmosphere within the group.",
    "The learner demonstrates some understanding of the social relevance of the project.",
    "The learner refrains from expressing negative emotions during group work.",
    "The learner participates enthusiastically and diligently in the project."
  ];

  const creativityItems = [
    "The learner demonstrates flexibility with respect to project roles.",
    "The learner displays willingness to consider different sources of information, tools, or materials.",
    "The learner takes initiative to complete the project tasks.",
    "The learner builds on the unique elements introduced earlier, or incorporates them at this stage.",
    "The learner shows evidence of having considered and selected some ideas from the brainstorming stage.",
    "The product created is innovative and useful to the community."
  ];

  const renderCheckboxSection = (title, items, category) => {
    const checkedIndices = stage2Data[category] || [];
    const total = checkedIndices.length;

    return (
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          backgroundColor: '#F4A460',
          color: 'white',
          padding: '8px 12px',
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '8px'
        }}>
          {title}
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '6px',
              fontSize: '11px',
              lineHeight: '1.4'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #333',
                marginRight: '8px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1px',
                fontSize: '12px'
              }}>
                {checkedIndices.includes(index) && '✓'}
              </div>
              <span>{item}</span>
            </div>
          ))}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginTop: '10px',
            fontSize: '11px',
            fontWeight: 'bold'
          }}>
            <span style={{ marginRight: '10px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              {total}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderText = (text) => {
    if (!text || text.trim() === '') return <div style={{ fontSize: '11px', color: '#999' }}>-</div>;
    return <div style={{ fontSize: '11px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>{text}</div>;
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Decorative Corners */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '10px',
        textAlign: 'center',
        marginBottom: '20px'
      }}>
        Stage 2
      </div>

      {/* Teacher Assessment Label */}
      <div style={{
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '8px 14px',
        fontWeight: 'bold',
        fontSize: '12px',
        display: 'inline-block',
        marginBottom: '12px'
      }}>
        Teacher Assessment
      </div>

      <div style={{
        fontSize: '11px',
        fontWeight: 'bold',
        marginBottom: '12px'
      }}>
        Tick (✓) all statements that apply.
      </div>

      {renderCheckboxSection('Awareness', awarenessItems, 'awareness')}
      {renderCheckboxSection('Sensitivity', sensitivityItems, 'sensitivity')}
      {renderCheckboxSection('Creativity', creativityItems, 'creativity')}

      {/* Comments Section */}
      <div style={{ marginTop: '20px' }}>
        <div style={{
          fontWeight: 'bold',
          fontSize: '11px',
          marginBottom: '8px'
        }}>
          Brief comments and pedagogical interventions recommended:
        </div>
        <div style={{
          backgroundColor: '#FFE5D5',
          padding: '12px',
          minHeight: '80px',
          borderRadius: '4px'
        }}>
          {renderText(stage2Data.comments)}
        </div>
      </div>

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '10px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        14
      </div>

      {/* Bottom decorative corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartBPage4;
